import React from "react";

export default function LayerToggle({
  checked,
  children,
  onChange,
  disabled = false,
  title,
}) {
  return (
    <label
      title={title}
      className={`flex items-center font-normal text-xs space-x-1 mb-0 select-none ${
        disabled ? "text-gray-400 cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      <input
        onChange={onChange}
        checked={!!checked}
        disabled={disabled}
        type="checkbox"
      />
      <div>{children}</div>
    </label>
  );
}
